import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { LANGUAGES } from '../../types/language';
import { navCopy } from '../../data/translations/nav';
export function LanguageToggle({
  className = ''
}: {
  className?: string;
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const copy = navCopy[language];
  return <div role="group" aria-label={copy.languageLabel} className={`flex items-center gap-1.5 text-xs tracking-wider ${className}`} data-id="element-213" data-mp="2xpdhquflfmgu">
      {LANGUAGES.map((entry, index) => {
      const isActive = entry.code === language;
      return <React.Fragment key={entry.code} data-id="element-214" data-mp="3ccgh76nh856t" data-mpi={index}>
            {index > 0 && <span aria-hidden="true" className="text-ink-900/25" data-id="element-215" data-mp="3hbjm8r3gibes">
                |
              </span>}
            <button type="button" onClick={() => setLanguage(entry.code)} aria-pressed={isActive} className={`transition-colors duration-200 focus:outline-none focus-visible:ring-1 focus-visible:ring-bronze-400 rounded px-0.5 ${isActive ? 'text-bronze-600 font-bold' : 'text-ink-600 hover:text-bronze-600'}`} data-id="element-216" data-mp="3le65w4pz4q0w">
              {entry.label}
            </button>
          </React.Fragment>;
    })}
    </div>;
}